import React from "react";
import { useMediaQuery } from "react-responsive";

const Footer = () => {
  const isMobile = useMediaQuery({ query: "(max-width: 992px)" });

  return (
    <div className={`footer-inner`}>
      <div className={`${isMobile ? "db" : " df jcsb"}`}>
        <div>
          <div className="text14 mb20">Contact Us</div>
          <div className="text12 ">
            Plot # 10, IDA, Uppal, Hyderabad, Telangana 560039
          </div>
          <div className="text12">Phone: +91 9000011716 | +91 9000488466</div>
          <div className="text12">Email: info@bigdrumindia.com</div>
        </div>
        <div>
          <div className="text14">Location</div>
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d15228.890992665943!2d78.5488404!3d17.4010947!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcb993c125b9439%3A0x44fcaa4e823dc192!2sBig%20Drum%20India%20Private%20Limited!5e0!3m2!1sen!2sin!4v1687179958189!5m2!1sen!2sin"
            width={isMobile ? "100%" : "600"}
            height={isMobile ? "150" : "200"}
            style={{ border: 0 }}
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>
      </div>
      <div className="hor-line mv10" />
      <p className="white">
        2018 © Bigdrum India Pvt. Ltd. All rights reserved.
      </p>
    </div>
  );
};

export default Footer;
